<template>
  <v-card style="background-color:#ffff" class="py-0 mb-0 pt-0"  elevation="7">
    <v-row >
      <v-col cols="12" class="mx-6">
        <span class="headline font-weight-bold">Secretaria de Acuerdos</span>
        <p class="font-weight mb-0">
          Lic. Socorro<br>
          Titular
        </p>
      </v-col>

      <v-col cols="12" class="py-2 mb-0 pt-0">
        <v-card class="mx-4" color="#CED7DB">
          <v-toolbar
            color="#607D8B"
            dark
            dense
          >
            <v-toolbar-title>Registrar Toca</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- other menu -->
          </v-toolbar>
        </v-card>
        <!--<Tabla />-->
        <div class="mx-4 py-3" style="background-color:#CED7DB">
          <v-card class="mx-4" >
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-row class="mt-3">
                  <v-col
                    cols="12"
                    md="2"
                    class="py-0 mb-0 pt-0"
                  >
                    <v-text-field
                      outlined
                      v-model="expediente"
                      :rules="nameRules"
                      label="Expediente"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                    class="py-0 mb-0 pt-0"
                  >
                    <v-text-field
                      outlined
                      v-model="oficio"
                      :rules="nameRules"
                      :counter="10"
                      label="Num. Oficio"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                    class="py-0 mb-0 pt-0"
                  >
                    <Autocomplete
                      outlined
                      label="Municipio"
                      :items = "getMunicipiosActivos"
                      v-model="municipio_id"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" class="py-0 mb-0 pt-0">
                    {{juzgado_id}}
                    <Autocomplete
                      class = "inputField input-name p-3 styled-input"
                      label="Juzgado"
                      :items = "getJuzgadosByMateria"
                      v-model="juzgado_id"
                    />
                      <!--  -->

                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6"
                         class="py-0 mb-0 pt-0"
                  >
                    <div style="background-color:white">
                      <v-textarea
                        outlined
                        name="actor"
                        label="Actor"
                        v-model="actor"
                      ></v-textarea>
                    </div>

                  </v-col>

                  <v-col cols="12" md="6"
                         class="py-0 mb-0 pt-0"
                  >
                    <v-textarea
                      outlined
                      name="demandado"
                      label="Demandado"
                      v-model="demandado"
                    ></v-textarea>
                  </v-col>
                </v-row>

                <!-- selected tipo de juciio -->
                <v-row>
                  <v-col cols="12">
                    <v-card  color="#CED7DB">
                      <v-toolbar
                        color="#607D8B"
                        dark
                        dense
                      >
                        <v-toolbar-title>Materia del Jucio</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <!-- other menu -->
                      </v-toolbar>
                    </v-card>
                  </v-col>
                  Materia_ {{materia_id}} <br>
                  Via_ {{via_id}} <br>
                  Accion_ {{accion_id}} <br>
                  Reconvencion {{reconvencion}} <br>
                  Tiene_reconvencion: {{has_reconvencion}}
                  <v-col cols="12">
                    <div align="center">
                      <v-radio-group v-model="materia_id" row>
                        <v-radio label="Civil" value="1"></v-radio>
                        <v-radio label="Mercantil" value="2"></v-radio>
                      </v-radio-group>
                    </div>

                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6"
                         class="py-0 mb-0 pt-0"
                  >
                    <v-autocomplete
                      label="Materia Apelación"
                      item-text="nombre"
                      item-value="id"
                      persistent-hint
                      return-object
                      :items = "getAllTiposApelacion"
                      v-model="materia_apelacion"
                      outlined
                    />
                  </v-col>
                  <v-col cols="12" md="6"
                         class="py-0 mb-0 pt-0"
                  >
                    <v-autocomplete
                      label="Via"
                      item-text="nombre"
                      item-value="id"
                      :items = "filterVias"
                      v-model="via_id"
                      persistent-hint
                      return-object
                      outlined
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="6"
                         class="py-0 mb-0 pt-0"
                  >
                    <v-autocomplete
                      label="Accion"
                      item-text="nombre"
                      item-value="id"
                      :items = "filterAcciones"
                      v-model="accion_id"
                      persistent-hint
                      return-object
                      outlined
                    />
                  </v-col>
                  <v-col cols="12" md="6"
                         class="py-0 mb-0 pt-0"
                  >
                    <v-checkbox
                      v-model="has_reconvencion"
                      label="Reconvención"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12"
                         class="py-0 mb-0 pt-0"

                  >
                    <v-autocomplete
                      label="Tiene Reconvención"
                      item-text="nombre"
                      item-value="id"
                      :items = "filterAcciones"
                      v-model="reconvencion"
                      persistent-hint
                      return-object
                      outlined
                      :disabled="!has_reconvencion"
                    />
                  </v-col>
                </v-row>
                <v-card flat>
                  <v-toolbar
                    color="primary"
                    dark
                    dense
                    flat
                  >
                    <h4>Seleccione Tipo de Registro</h4>
                  </v-toolbar>
                  <v-card-text class="py-0 mb-0 pt-0">
                    <v-row>
                      <v-col cols="12" md="5" class="py-0 mb-0 pt-0">
                        <v-radio-group v-model="tipo_registro">
                          <v-radio
                            label="Para Turnar"
                            id="cero"
                            value="0"
                          ></v-radio>

                          <v-radio
                            label="Sin Turnar"
                            id="three"
                            value="3"
                          ></v-radio>

                          <v-radio
                            label="Para Registrar Amparo"
                            id="five"
                            value="5"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-divider vertical></v-divider>

                      <v-col cols="12" md="6"
                             class="py-0 mb-0 pt-0"
                      >
                        <v-menu
                          v-model="menu_fecha_recepcion"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="fecha_recepcion"
                              label="Recepción"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="fecha_recepcion" @input="menu_fecha_recepcion = false">
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu_fecha_citacion"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-show="tipo_registro=='0' "
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="fecha_citacion"
                              label="Citación"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              v-show="tipo_registro=='0' "
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="fecha_citacion" @input="menu_fecha_citacion = false">
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          v-model="menu_fecha_turno"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          v-show="tipo_registro=='0' "

                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="fecha_turno"
                              label="Turno"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-on="on"
                              v-show="tipo_registro=='0' "

                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="fecha_turno" @input="menu_fecha_turno = false">
                          </v-date-picker>
                        </v-menu>

                      </v-col>
                    </v-row>
                    recepcion: {{fecha_recepcion}}<br>
                    citacion: {{fecha_citacion}}<br>
                    turno: {{fecha_turno}}<br>
                    <v-row>
                      <v-col cols="12" class="py-0 mb-0 pt-1">
                        <BaseSelect
                          label="Ponencia"
                          :items = "ponencias"
                          v-model="ponencia_id"
                          v-show="tipo_registro=='5'"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-btn
                  block
                  color="primary"
                  :loading="loading"
                  :disabled="!valid"
                  @click="validate"
                  class="mb-6"
                >
                  GUARDAR
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-divider></v-divider>

              </v-container>
            </v-form>
          </v-card>


        </div>




      </v-col>
    </v-row>


    <v-row class="mx-2 mt-0">
      <v-col cols="12">
        <v-card color="#CED7DB">

        </v-card>




      </v-col>
    </v-row>
  </v-card>
</template>

<style>
  .input-name {
    background-color: #ffff;
    margin-top: 0px;
  }
</style>

<script>
  import {mapGetters, mapMutations} from "vuex";
  import BaseSelect from "../../components/BaseSelect.vue";
  import Autocomplete from "../../components/Autocomplete";

  export default {
    components: { BaseSelect, Autocomplete },
    data: () => ({
      menu_fecha_recepcion: false,
      menu_fecha_citacion: false,
      menu_fecha_turno: false,

      municipio_id:'', //municipio_id =>para filtrar los juzgados por municipio_id
      materia_id:'', //Civil o Mercantil este es para filtrar el tipo de juciio y traernos as las vias y demas
      reconvencion:null,  //el objeto seleccionado de la reconvencion
      has_reconvencion:false,   //para comportamiento de mostrar o deshabilitar el campo reconvencion
      tipo_registro:'',  //para comportamiento de mostrar ponencias y sirve para registrar un amparo

      ponencias:[
        {id:1, nombre: "algo"}
      ],
      ponencia_id:'',


      valid: false,
      loading: false,

      toca: "",
      expediente: "",
      oficio: "",
      juzgado_id: "",
      actor: "",
      demandado: "",
      materia_apelacion: "",
      via_id: "",
      accion_id: "",
      fecha_recepcion: "",
      fecha_citacion: "",
      fecha_turno: "",

      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
      this.$store.dispatch("GET_ALL_MUNICIPIOS", { url: "municipios" }).then(res => {
          // console.log("Hecho los MUNCIPIOS");
        });
      this.$store.dispatch("GET_ALL_TIPOS_APELACION", { url: "tipo-apelaciones" }).then(res => {
          // console.log("Hecho los tipo de apelacion");
        });
      this.$store.dispatch("GET_ALL_VIAS", { url: "vias" }).then(res => {
        // console.log("Hecho las vias desde Tocas", res.data.data);
      });
    },

    watch: {
      municipio_id() {
        if (this.municipio_id) {
          this.juzgado_id = '' //al escoger otro municipio borrar el juzgado
          this.getJuzgadosByMunicipio();
        }
      },
      materia_id() {
        //cada vez que cambie la materia_id debemos traer los o filtrar las  acciones
        //para el tema de traer las vias como no som muchas entonces los que hice fue traer todas las vias y despues hacerle un filter
        if (this.materia_id) {
          this.via_id = ''
          this.accion_id = ''
          this.getAccionesByMateria();
        }
      },
      has_reconvencion(){
        if (!this.has_reconvencion) {
          this.reconvencion=null
        }
      },
      tipo_registro(){
        switch (this.tipo_registro) {
          case "0": //para turnar =>Mostrar las 3 fechas
            this.fecha_citacion = ""
            break;
          case "3": case "5":
            this.fecha_citacion = ''
            this.fecha_turno=''
            break;
        }

      },
    },
    computed: {
      ...mapGetters(["getMunicipiosActivos",
                     "getJuzgadosByMateria",
                     "getAllTiposApelacion",
                     "getViasActivas", //tre tpdas las Vias y despues aqui en Tocas hago el filtrado por materia_id
                     "getAllAcciones" //traigo todas Acciones pero las que pertenecesn a la mayteria_id
                     ]),
      filterVias(){
         return  this.getViasActivas.filter(via => via.materia_id == this.materia_id);
      },
      filterAcciones(){
        return  this.getAllAcciones.filter(accion => accion.materia_id == this.materia_id);
      },
    },
    methods:{
      validate() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          this.save();
        }
      },
      save() {
        console.log("guardando");

        var data = {
          toca: this.toca,
          expediente: this.expediente,
          oficio: this.oficio,
          juzgado_id: this.juzgado_id,
          actor: this.actor,
          demandado: this.demandado,
          materia_apelacion: this.materia_apelacion.id,
          via_id: this.via_id.id,
          accion_id: this.accion_id.id,
          reconvencion_nombre: this.reconvencion.nombre || undefined,
          fecha_recepcion: this.fecha_recepcion,
          fecha_citacion: this.fecha_citacion,
          fecha_turno: this.fecha_turno,
          tipo_registro: this.tipo_registro
        }
        this.$store.dispatch("CREATE_TOCA",
          { url: "tocas/store", data:data})
          .then(response => {

            if (response.data.status == 'error') {
              var titleSwal = 'Error!!!'
              var textSwal = "HUBO ERROR"
              var iconSwal = "error"
              var timerSwal = 3000

              this.loading = false;
              this.$swal({
                title: titleSwal,
                text: textSwal,
                icon: iconSwal,
                confirmButtonText: "Aceptar",
                timer: timerSwal
              });

            } else {
              var titleSwal = 'Exito!!!'
              var textSwal = 'Toca Registrado'
              var iconSwal = "success"
              var timerSwal = 1000

              this.loading = false;
              this.$swal({
                title: titleSwal,
                text: textSwal,
                icon: iconSwal,
                confirmButtonText: "Aceptar",
                timer: timerSwal
              });

              this.$router.push("/secacuerdos");
            }



          })
          .catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: "No se pudo guardar la Cédula",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
      },

      getJuzgadosByMunicipio() {
        // this.$store.dispatch("GET_ALL_JUZGADOS", { url: `juzgados/getActivos/${this.municipio_id}` }).then(res => {
        this.$store.dispatch("GET_ALL_JUZGADOS", { url: 'juzgados' }).then(res => {
            console.log("Hecho los JUZGADOS");
          });
      },
      getAccionesByMateria() {
        //get las acciones
        this.$store.dispatch("GET_ACCIONES_BY_MATERIA", { url: "/acciones/getacciones/" + this.materia_id}).then(res=>{});
      },
    }
  };
</script>